import { Record as record, List } from 'immutable';

import { construct, fields } from '../../../../src/helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';

const fieldSchema = {
    start: [fields.datetime],
    end: [fields.datetime],
    used: [fields.bool]
};

export default class CompensationPeriod extends record(
    getDefaults(fieldSchema)
) {
    static fromJSON(json = {}) {
        return construct(CompensationPeriod, json, getResolvers(fieldSchema));
    }

    get id() {
        return this.start.unix();
    }

    getDays() {
        const { start, end } = this;
        let days = new List();
        if (start && end) {
            for (
                let cursor = start.clone().startOf('day');
                cursor.isBefore(end);
                cursor = cursor.add(1, 'day')
            ) {
                days = days.push(cursor.clone());
            }
        }
        return days;
    }
}
